var _clipPath, _g, _clipPath2, _g2, _clipPath3, _clipPath4, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer6Night(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "917px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-6",
    serifId: "layer 6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -12,
    width: 1440,
    height: 928.599
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "city-2",
    serifId: "city 2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "city-3",
    serifId: "city 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.098,444.09C810.098,443.409 809.833,442.755 809.358,442.266C807.951,440.817 804.908,437.683 803.556,436.291C803.127,435.849 802.537,435.599 801.921,435.599C800.007,435.599 795.743,435.599 793.787,435.599C793.14,435.599 792.523,435.874 792.091,436.356C790.809,437.784 788.045,440.861 786.769,442.282C786.337,442.762 786.098,443.386 786.098,444.032C786.098,448.973 786.098,470.783 786.098,478.378C786.098,479.825 787.271,480.997 788.717,480.997C793.333,480.997 802.863,480.997 807.479,480.997C808.926,480.997 810.098,479.825 810.098,478.378C810.098,470.813 810.098,449.143 810.098,444.09Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.098,456.917C790.098,455.471 788.926,454.298 787.479,454.298C784.975,454.298 781.221,454.298 778.717,454.298C777.271,454.298 776.098,455.471 776.098,456.917C776.098,463.864 776.098,482.702 776.098,489.649C776.098,491.095 777.271,492.268 778.717,492.268C781.221,492.268 784.975,492.268 787.479,492.268C788.926,492.268 790.098,491.095 790.098,489.649C790.098,482.702 790.098,463.864 790.098,456.917Z",
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.662,440.164C820.498,439.453 819.866,438.949 819.137,438.949C818.408,438.949 817.775,439.453 817.612,440.164C815.846,447.383 813.175,459.343 813.175,465.663C813.175,471.524 815.847,476.283 819.137,476.283C822.427,476.283 825.098,471.524 825.098,465.663C825.098,459.343 822.428,447.383 820.662,440.164Z",
    style: {
      fill: "url(#_Linear4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.605,429.746C829.418,429.068 828.801,428.599 828.098,428.599C827.395,428.599 826.779,429.068 826.591,429.746C824.534,436.815 821.098,449.609 821.098,456.225C821.098,462.086 824.235,466.845 828.098,466.845C831.962,466.845 835.098,462.086 835.098,456.225C835.098,449.609 831.663,436.815 829.605,429.746Z",
    style: {
      fill: "url(#_Linear5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-5",
    serifId: "trees 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1195.61,344.746C1195.42,344.068 1194.8,343.599 1194.1,343.599C1193.39,343.599 1192.78,344.068 1192.59,344.746C1190.53,351.815 1187.1,364.609 1187.1,371.225C1187.1,377.086 1190.24,381.845 1194.1,381.845C1197.96,381.845 1201.1,377.086 1201.1,371.225C1201.1,364.609 1197.66,351.815 1195.61,344.746Z",
    style: {
      fill: "url(#_Linear6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.58,329.527C1207.36,328.894 1206.77,328.469 1206.1,328.469C1205.43,328.469 1204.84,328.894 1204.62,329.527C1202.06,336.771 1197.1,351.827 1197.1,359.392C1197.1,365.713 1201.13,370.845 1206.1,370.845C1211.07,370.845 1215.1,365.713 1215.1,359.392C1215.1,351.827 1210.13,336.771 1207.58,329.527Z",
    style: {
      fill: "url(#_Linear7)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.046,272.771C62.814,272.672 62.551,272.673 62.32,272.774C62.089,272.875 61.91,273.067 61.825,273.305C60.741,276.351 57.286,286.06 56.562,288.097C56.473,288.347 56.427,288.61 56.427,288.874C56.427,291.787 56.427,309.608 56.427,309.608C56.427,309.608 68.672,309.591 74.074,309.584C74.721,309.583 75.338,309.312 75.776,308.837C76.215,308.361 76.434,307.724 76.382,307.079C75.775,299.526 74,277.462 74,277.462C74,277.462 65.805,273.953 63.046,272.771Z",
    style: {
      fill: "url(#_Linear8)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.046,272.771C62.814,272.672 62.551,272.673 62.32,272.774C62.089,272.875 61.91,273.067 61.825,273.305C60.741,276.351 57.286,286.06 56.562,288.097C56.473,288.347 56.427,288.61 56.427,288.874C56.427,291.787 56.427,309.608 56.427,309.608C56.427,309.608 68.672,309.591 74.074,309.584C74.721,309.583 75.338,309.312 75.776,308.837C76.215,308.361 76.434,307.724 76.382,307.079C75.775,299.526 74,277.462 74,277.462C74,277.462 65.805,273.953 63.046,272.771Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.899,294.563C75.899,294.101 75.716,293.658 75.389,293.331C75.062,293.004 74.619,292.821 74.156,292.821C73.769,292.821 73.359,292.821 72.972,292.821C72.509,292.821 72.066,293.004 71.739,293.331C71.412,293.658 71.229,294.101 71.229,294.563C71.229,297.366 71.229,302.841 71.229,305.643C71.229,306.105 71.412,306.549 71.739,306.876C72.066,307.202 72.509,307.386 72.972,307.386C73.359,307.386 73.769,307.386 74.156,307.386C74.619,307.386 75.062,307.202 75.389,306.876C75.716,306.549 75.899,306.105 75.899,305.643C75.899,302.841 75.899,297.366 75.899,294.563Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image11",
    x: 76.252,
    y: 301.556,
    width: "4.671px",
    height: "14.565px",
    transform: "matrix(0.934128,0,0,0.971032,0,0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M72,271.766C72,270.983 71.365,270.348 70.582,270.348C70.581,270.348 70.581,270.348 70.58,270.348C69.797,270.348 69.162,270.983 69.162,271.766C69.162,274.026 69.162,278.194 69.162,278.194L72,278.194L72,271.766Z",
    style: {
      fill: "url(#_Linear12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.874,269.33C82.256,268.963 82.788,268.796 83.31,268.88C83.833,268.964 84.286,269.289 84.533,269.757C86.845,274.133 92.287,284.436 93.557,286.841C93.734,287.174 93.826,287.546 93.826,287.924C93.826,291.27 93.826,308.089 93.826,308.089L65.605,308.089C64.332,308.089 63.296,307.062 63.287,305.789C63.252,301.291 63.176,291.499 63.151,288.349C63.146,287.713 63.404,287.102 63.862,286.66C66.772,283.861 77.719,273.328 81.874,269.33Z",
    style: {
      fill: "url(#_Linear13)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.874,269.33C82.256,268.963 82.788,268.796 83.31,268.88C83.833,268.964 84.286,269.289 84.533,269.757C86.845,274.133 92.287,284.436 93.557,286.841C93.734,287.174 93.826,287.546 93.826,287.924C93.826,291.27 93.826,308.089 93.826,308.089L65.605,308.089C64.332,308.089 63.296,307.062 63.287,305.789C63.252,301.291 63.176,291.499 63.151,288.349C63.146,287.713 63.404,287.102 63.862,286.66C66.772,283.861 77.719,273.328 81.874,269.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.319,288.659C91.318,288.437 91.263,288.219 91.16,288.023C90.252,286.293 85.671,277.561 84.32,274.986C84.245,274.844 84.098,274.753 83.937,274.751C83.776,274.748 83.626,274.834 83.547,274.974C82.091,277.543 77.093,286.368 76.079,288.156C75.961,288.365 75.899,288.6 75.899,288.839C75.899,291.523 75.899,308.089 75.899,308.089L91.487,308.087C91.487,308.087 91.342,291.266 91.319,288.659Z",
    style: {
      fill: "#143f59"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "mountains-5",
    serifId: "mountains 5",
    d: "M-0,277.6C-0,277.6 70.108,309.552 99,306.708C132.078,303.453 148.664,225.235 192,236.142C249.806,250.692 257.881,371.359 321.5,411.685C348.286,428.664 361.082,380.624 398,388.685C453.46,400.795 491.709,536.902 608.5,541.685C733.079,546.788 793.859,443.545 873.5,438.599C944.393,434.197 1002.39,516.489 1068.83,486.515C1153.21,448.444 1224.18,307.175 1267,296.089C1316.83,283.19 1322.54,366.969 1356.93,359.491C1412.75,347.356 1440,228.685 1440,228.685L1440,916.599L0.001,916.599L-0,277.6Z",
    style: {
      fill: "url(#_Linear15)",
      fillRule: "nonzero"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0,277.6C-0,277.6 70.108,309.552 99,306.708C132.078,303.453 148.664,225.235 192,236.142C249.806,250.692 257.881,371.359 321.5,411.685C348.286,428.664 361.082,380.624 398,388.685C453.46,400.795 491.709,536.902 608.5,541.685C733.079,546.788 793.859,443.545 873.5,438.599C944.393,434.197 1002.39,516.489 1068.83,486.515C1153.21,448.444 1224.18,307.175 1267,296.089C1316.83,283.19 1322.54,366.969 1356.93,359.491C1412.75,347.356 1440,228.685 1440,228.685L1440,916.599L0.001,916.599L-0,277.6Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.439,305.532C121.12,309.499 146.85,315.784 129.187,327.905C122.725,332.339 130.763,341.848 149.159,347.32C183.089,357.411 239.646,361.373 241.633,365.22C244.987,371.715 217.36,374.261 227.537,387.876C232.966,395.14 288.848,410.331 324.41,413.306C318.169,409.769 310.925,403.408 310.925,403.408C286.257,398.748 234.914,388.945 234.818,381.539C234.723,374.203 264.744,369.551 246.383,360.366C230.569,352.455 121.16,344.046 140.552,326.421C151.591,316.389 135.826,308.67 106.876,301.712L104.439,305.532Z",
    style: {
      fill: "#317f92",
      fillOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M541.791,42.073C542.432,40.963 542.354,39.578 541.592,38.547C540.83,37.516 539.53,37.034 538.28,37.32C525.823,40.138 516.6,50.202 516.6,62.17C516.6,74.138 525.823,84.203 538.278,87.029C539.531,87.316 540.835,86.833 541.599,85.799C542.363,84.765 542.441,83.376 541.799,82.263C538.823,76.681 536.76,69.638 536.76,62.17C536.76,54.702 538.823,47.66 541.791,42.073Z",
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4,6.456C35.426,6.156 35.677,5.927 35.978,5.927C36.278,5.927 36.529,6.156 36.556,6.456C36.653,7.542 36.752,8.655 36.846,9.695C37.101,12.546 39.359,14.806 42.21,15.065C42.282,15.072 42.355,15.078 42.427,15.085C42.726,15.112 42.955,15.363 42.955,15.663C42.955,15.963 42.726,16.214 42.427,16.241C42.336,16.249 42.246,16.257 42.155,16.266C39.329,16.522 37.081,18.748 36.797,21.572C36.718,22.358 36.636,23.179 36.555,23.984C36.525,24.28 36.276,24.506 35.978,24.506C35.68,24.506 35.43,24.28 35.4,23.984C35.319,23.179 35.237,22.358 35.158,21.572C34.874,18.748 32.626,16.522 29.8,16.266C29.709,16.257 29.619,16.249 29.528,16.241C29.229,16.214 29,15.963 29,15.663C29,15.363 29.229,15.112 29.528,15.085C29.601,15.078 29.673,15.072 29.746,15.065C32.596,14.806 34.854,12.546 35.11,9.695C35.203,8.655 35.302,7.542 35.4,6.456Z",
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376,202.456C1376.03,202.156 1376.28,201.927 1376.58,201.927C1376.88,201.927 1377.13,202.156 1377.15,202.456C1377.25,203.542 1377.35,204.655 1377.44,205.695C1377.7,208.546 1379.96,210.806 1382.81,211.065C1382.88,211.072 1382.95,211.078 1383.03,211.085C1383.33,211.112 1383.56,211.363 1383.56,211.663C1383.56,211.963 1383.33,212.214 1383.03,212.241C1382.94,212.249 1382.85,212.257 1382.76,212.266C1379.93,212.522 1377.68,214.748 1377.4,217.572C1377.32,218.358 1377.24,219.179 1377.15,219.984C1377.12,220.28 1376.88,220.506 1376.58,220.506C1376.28,220.506 1376.03,220.28 1376,219.984C1375.92,219.179 1375.84,218.358 1375.76,217.572C1375.47,214.748 1373.23,212.522 1370.4,212.266C1370.31,212.257 1370.22,212.249 1370.13,212.241C1369.83,212.214 1369.6,211.963 1369.6,211.663C1369.6,211.363 1369.83,211.112 1370.13,211.085C1370.2,211.078 1370.27,211.072 1370.35,211.065C1373.2,210.806 1375.45,208.546 1375.71,205.695C1375.8,204.655 1375.9,203.542 1376,202.456Z",
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.586,29.279C955.613,28.979 955.863,28.75 956.164,28.75C956.464,28.75 956.715,28.979 956.742,29.279C956.925,31.323 957.124,33.549 957.296,35.468C957.551,38.319 959.809,40.58 962.66,40.839C963.483,40.913 964.347,40.992 965.2,41.069C965.499,41.096 965.728,41.347 965.728,41.647C965.728,41.947 965.499,42.198 965.2,42.225C964.328,42.304 963.445,42.384 962.606,42.461C959.779,42.717 957.532,44.943 957.248,47.767C957.087,49.363 956.908,51.152 956.741,52.807C956.711,53.103 956.462,53.329 956.164,53.329C955.866,53.329 955.616,53.103 955.586,52.807C955.42,51.152 955.24,49.363 955.08,47.767C954.796,44.943 952.549,42.717 949.722,42.461C948.883,42.384 947.999,42.304 947.128,42.225C946.829,42.198 946.6,41.947 946.6,41.647C946.6,41.347 946.829,41.096 947.128,41.069C947.981,40.992 948.845,40.913 949.668,40.839C952.519,40.58 954.776,38.319 955.032,35.468C955.204,33.549 955.403,31.323 955.586,29.279Z",
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.437,154.698C85.464,154.399 85.715,154.169 86.015,154.169C86.315,154.169 86.566,154.399 86.593,154.698C86.642,155.244 86.69,155.786 86.737,156.305C86.946,158.635 88.79,160.482 91.12,160.694C91.122,160.694 91.124,160.694 91.126,160.694C91.384,160.718 91.581,160.934 91.581,161.192C91.581,161.451 91.384,161.667 91.126,161.69C91.115,161.691 91.105,161.692 91.094,161.693C88.774,161.904 86.929,163.731 86.696,166.049C86.662,166.386 86.627,166.73 86.592,167.077C86.563,167.374 86.313,167.599 86.015,167.599C85.717,167.599 85.467,167.374 85.438,167.077C85.403,166.73 85.368,166.386 85.334,166.049C85.101,163.731 83.257,161.904 80.936,161.693C80.925,161.692 80.915,161.691 80.904,161.69C80.646,161.667 80.449,161.451 80.449,161.192C80.449,160.934 80.646,160.718 80.904,160.694C80.906,160.694 80.908,160.694 80.91,160.694C83.24,160.482 85.084,158.635 85.293,156.305C85.34,155.786 85.388,155.244 85.437,154.698Z",
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 92.681,
    r: 3.4,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 39.139,
    r: 1.9,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1402,
    cy: 58.745,
    r: 3.4,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.67
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.5,
    cy: 149.917,
    r: 1.9,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1022,
    cy: 99.482,
    r: 3.4,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1069.3,
    cy: 75.982,
    r: 1.9,
    style: {
      fill: "#78d3e5",
      fillOpacity: 0.54
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image11",
    width: "5px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAPCAYAAAAs9AWDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA0klEQVQYlS3NW27CMBBA0euJR+RBSVACq+4Suj6+iiIZ4rGCo+lPzwZO8J9vT+vKZVkoKfF6vZBPKQzDwP5+Y2bc7ndE+x4AM6NtWyxn4r5tlFIY5xlqBSCqKqoK7gBs20Zc1xVVJYRA13WICBJC4GueEREA9n0nujs1Z9q2BWC83ZBxHKn/gZlRUkJEhOM4yDnTNA0xRiSlxHC9oqrUWsk5I6fTid/HA1VFRHB3xMyYponn84m7cz6fkeuykHOm73u6rsPMiITAZZpABP98EBH+ANqWZGw5oO/EAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.92986e-14,-478.482,1111.62,6.80669e-14,720,707.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c3555",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#082b4a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001733",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer6Night);
export default __webpack_public_path__ + "static/media/layer6-night.82cb6ebd59894913d528bb1937a2465d.svg";
export { ForwardRef as ReactComponent };